import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    CreateWasteProducerBody,
    UpdateWasteProducerBody,
    WasteProducerResponse,
    createWasteProducer,
    updateWasteProducer,
    deleteWasteProducer,
} from '../../services/apiSLTP/sites/wasteProducers';

type UseCreateWasteProducerMutationOptions = MutationOptions<WasteProducerResponse, Error, CreateWasteProducerBody>;

type UseUpdateWasteProducerMutationOptions = MutationOptions<WasteProducerResponse, Error, { id: string; data: UpdateWasteProducerBody }>;

type UseDeleteWasteProducerMutationOptions = MutationOptions<WasteProducerResponse, Error, string>;

export const useCreateWasteProducerMutation = (options?: UseCreateWasteProducerMutationOptions) => {
    const wasteProducerMutation: MutationFunction<WasteProducerResponse, CreateWasteProducerBody> = async (data) => {
        try {
            const response: WasteProducerResponse = await createWasteProducer(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during waste producer creation');
        }
    };

    return useMutation(wasteProducerMutation, options);
};

export const useUpdateWasteProducerMutation = (options?: UseUpdateWasteProducerMutationOptions) => {
    const wasteProducerMutation: MutationFunction<WasteProducerResponse, { id: string; data: UpdateWasteProducerBody }> = async ({ id, data }) => {
        try {
            const response: WasteProducerResponse = await updateWasteProducer(id, data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during waste producer update');
        }
    };

    return useMutation(wasteProducerMutation, options);
};

export const useDeleteWasteProducerMutation = (options?: UseDeleteWasteProducerMutationOptions) => {
    const wasteProducerMutation: MutationFunction<WasteProducerResponse, string> = async (id) => {
        try {
            const response: WasteProducerResponse = await deleteWasteProducer(id);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during waste producer deletion');
        }
    };

    return useMutation(wasteProducerMutation, options);
};
